import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import UniformAccordion from '../../../../../../uniform/components/accordion/src/accordion.tsx';
import UniformAccordionsSection from '../../../../../../uniform/components/accordions-section/src/accordions-section.tsx';

import type { EmbeddedQuestionData } from './embedded-question.tsx';

const containerCss = css({
	marginBlockStart: token('space.300'),
	marginBlockEnd: token('space.300'),
});

interface EmbeddedQuestionsContainerData {
	heading: string;
	accordions: EmbeddedQuestionData[];
}

export interface EmbeddedQuestionsContainerProps {
	data: unknown;
}

export const EmbeddedQuestionsContainer = (props: EmbeddedQuestionsContainerProps) => {
	const { data } = props;
	const { heading, accordions } = data as EmbeddedQuestionsContainerData;
	return (
		<div css={containerCss}>
			<UniformAccordionsSection heading={heading}>
				{accordions.map((accordion, index) => (
					<UniformAccordion
						key={index}
						header={accordion.title}
						anchorId={accordion.anchorId}
						richText={accordion.content}
					/>
				))}
			</UniformAccordionsSection>
		</div>
	);
};
